import React, { useState } from "react";
import tw from "twin.macro";
import styled from "styled-components";
import AnimationRevealPage from "../helpers/AnimationRevealPage";
import Header from "../components/headers/light";
import Footer from "../components/footers/FiveColumnWithBackground";
import accesslogIllustration from "../images/accesslog-tanga-illustration.png";
import eventIllustration from "../images/event-tanga-illustration.png";

// NOUVEAU — Import du modal de demande de démonstration
import DemoModal from "../components/cta/DemoModal.js";

const Container = tw.div`max-w-screen-xl mx-auto py-16 px-4`;
const Heading = tw.h2`text-4xl font-bold text-center mb-12`;
const ProductsGrid = tw.div`grid gap-8 md:grid-cols-2`;

const ProductCard = styled.div`
  ${tw`bg-white rounded-lg shadow-lg p-8 flex flex-col items-center text-center`}
`;

const ProductImage = styled.img`
  ${tw`w-80 h-80 object-contain mb-6`}
`;

const ProductTitle = tw.h3`text-2xl font-semibold mb-2`;
const ProductDesc = tw.p`text-gray-600 mb-4`;

const ProductButton = styled.a`
  ${tw`mt-2 inline-block px-6 py-3 rounded-lg font-semibold text-white`}
  background: linear-gradient(135deg, #2563eb, #7c3aed);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
  }
`;

// NOUVEAU — Même style que ProductButton, mais pour le bouton qui ouvre le modal
const DemoButton = styled.button`
  ${tw`mt-2 inline-block px-6 py-3 rounded-lg font-semibold text-white`}
  background: linear-gradient(135deg, #2563eb, #7c3aed);
  transition: all 0.3s ease;
  border: none;
  cursor: pointer;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
  }
`;

const products = [
  {
    title: "Tanga Access Log",
    description:
      "Tanga Access Log est une solution complète conçue pour assurer une gestion efficace, sécurisée et transparente des visiteurs. Adaptée aux entreprises, écoles, hôpitaux et même aux ménages, elle offre aux agents de sécurité et aux gestionnaires d'établissement des outils modernes pour contrôler, enregistrer et suivre les accès. Grâce à une interface intuitive et des rapports détaillés, Tanga Access Log permet d'améliorer la sécurité, de simplifier l'accueil et de garantir la traçabilité de chaque visite, tout en respectant la confidentialité des données.",
    image: accesslogIllustration,
    actionText: "Demander une Démo",

    // MODIFIÉ — Plus besoin d'URL pour le bouton de démo
    actionType: "demo",
  },
  {
    title: "Tanga Event Manager",
    description:
      "Tanga Event Manager centralise la gestion de tous vos événements professionnels, sociaux ou culturels. Cette solution innovante réduit jusqu'à 40% le temps d'organisation grâce à des indicateurs de performance (KPIs) précis et un parcours utilisateur simple et personnalisable. Gérez facilement les invitations, le check-in, le suivi des participants et l'analyse post-événement, tout en offrant une expérience fluide et moderne à vos invités. Idéal pour les organisateurs souhaitant gagner en efficacité et en visibilité.",
    image: eventIllustration,
    actionText: "Gérer vos événements",
    actionUrl: "https://dashboard.tangagroup.africa/signup-events",

    // NOUVEAU — Le deuxième produit garde son fonctionnement actuel
    actionType: "link",
  },
];

export default function Products() {
  // NOUVEAU — Contrôle l'ouverture du DemoModal
  const [showDemoModal, setShowDemoModal] = useState(false);


  return (
    <>
      {/* MODIFIÉ — La page reste dans AnimationRevealPage */}
      <AnimationRevealPage>
        <Header />

        <Container>
          <Heading>Nos Produits</Heading>

          <ProductsGrid>
            {products.map((product, idx) => (
              <ProductCard key={idx}>
                <ProductImage
                  src={product.image}
                  alt={product.title}
                />

                <ProductTitle>{product.title}</ProductTitle>

                <ProductDesc>{product.description}</ProductDesc>

                {product.actionType === "demo" ? (
                  <DemoButton
                    type="button"
                    onClick={() => setShowDemoModal(true)}
                  >
                    {product.actionText}
                  </DemoButton>
                ) : (
                  <ProductButton href={product.actionUrl}>
                    {product.actionText}
                  </ProductButton>
                )}
              </ProductCard>
            ))}
          </ProductsGrid>
        </Container>

        <Footer />
      </AnimationRevealPage>

      {/* NOUVEAU — Le modal est en dehors de AnimationRevealPage */}
      <DemoModal
        isOpen={showDemoModal}
        onClose={() => setShowDemoModal(false)}
        productName="Tanga Access Log"
      />
    </>
  );


}

